import './MyMahiError.scss'
import React from "react";
import {ThemedLottiePlayerComponent} from "../../components/common/lottie-player/ThemedLottiePlayerComponent";
import {isMobileDevice} from "../../utils/WindowUtils";

export const MyMahiErrorPage: React.FC = () => {
    return (
        <div className={`background-complete general-container mymahi-error-container height-window 
        ${isMobileDevice() ? 'tertiary-blue-background' : ''}`}>
            <div className={`flex-center mymahi-error-lottie-container`}>
                <ThemedLottiePlayerComponent animation="fail"/>
            </div>
            <div className={`flex-center mymahi-complete-text-container`}>
                <span className={`font-white general-title general-result-title mymahi-error-title-font`}>
                    Something went wrong...
                </span>
                <span className={`flex-center font-white general-subtitle mymahi-error-title-text`}>
                    We were not able to verify your MyMahi Digital Learner ID.
                </span>
                <span className={`flex-center font-white general-subtitle mymahi-error-title-text`}>
                    Please return to the Emerge app and select a different ID.
                </span>
            </div>
        </div>
    )
}